import { Pipe, PipeTransform } from '@angular/core';
import { AssigneeOrganizationOption } from '@shared/ui-components/au-assignee-select/au-assignee-select.types';

@Pipe({
	name: 'assigneeQuickSearch',
})
export class AssigneeQuickSearchPipe implements PipeTransform {
	transform(
		assignees: AssigneeOrganizationOption[],
		searchText: string
	): AssigneeOrganizationOption[] {
		if (!searchText) {
			return assignees;
		}

		const localLowerCaseSearchText = searchText.toLocaleLowerCase();
		return assignees.map(assignee => {
			const filteredUsers = assignee.users.filter(
				user =>
					user.lastName.toLocaleLowerCase().includes(localLowerCaseSearchText) ||
					user.firstName.toLocaleLowerCase().includes(localLowerCaseSearchText)
			);

			return { ...assignee, users: filteredUsers };
		});
	}
}
